export enum GoToTeamSectionButtonType {
	Favourite = 'favourite',
	Followed = 'followed',
	Suggested = 'suggested'
}
